import { Skeleton, SkeletonRegion } from '@parsina/framework';
import { C, RADIUS } from '@parsina/framework/tokens';
import { useMyPageStrings } from './myPageStrings';

// ─────────────────────────────────────────────────────────────────────────────
// «صفحهٔ من» while the page is pending — its own shape on each surface
// (DESIGN_CONCEPT §2.4): the desktop rail (status card, template cards,
// section rows) beside one editor card; the phone's status card over the
// section list. One announced status region, kit blocks only, no words.
// ─────────────────────────────────────────────────────────────────────────────

const card = {
  background: C.card, border: `1px solid ${C.border}`, borderRadius: RADIUS.card, padding: '1rem',
  display: 'grid', gap: 10,
};

const Rows = ({ n, h = 44 }) => Array.from({ length: n }, (_, i) => (
  <div key={i} aria-hidden style={{ display: 'flex', alignItems: 'center', gap: 8, height: h }}>
    <Skeleton width={`${45 + ((i * 13) % 30)}%`} height={13} />
    <span style={{ flex: 1 }} />
    <Skeleton width={18} height={18} radius={5} />
    <Skeleton width={28} height={28} radius={8} />
  </div>
));

export function MyPageSkeleton() {
  const s = useMyPageStrings();
  return (
    <SkeletonRegion label={s('myPage.loading')} data-testid="my-page-loading">
      <div aria-hidden style={{ display: 'flex', flexWrap: 'wrap', gap: '1.25rem', alignItems: 'flex-start' }}>
        <div style={{ flex: '1 1 17rem', maxWidth: '22rem', display: 'grid', gap: '1rem' }}>
          <div style={card}>
            <Skeleton width="40%" height={14} />
            <Skeleton width="90%" height={12} />
            <Skeleton height={44} radius={10} />
            <Skeleton height={44} radius={10} />
          </div>
          <div style={card}>
            <Skeleton width="30%" height={14} />
            {[0, 1, 2].map((i) => <Skeleton key={i} height={68} radius={10} />)}
          </div>
          <div style={card}>
            <Skeleton width="35%" height={14} />
            <Rows n={7} />
          </div>
        </div>
        <div style={{ flex: '999 1 30rem', minWidth: 0, ...card, gap: 16, padding: '1.25rem' }}>
          <Skeleton width="25%" height={16} />
          {[0, 1].map((i) => (
            <div key={i} style={{ display: 'grid', gap: 8 }}>
              <Skeleton width={96} height={12} />
              <Skeleton height={44} radius={10} />
            </div>
          ))}
          <Skeleton width={96} height={12} />
          <Skeleton height={160} radius={10} />
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}><Skeleton width={96} height={36} radius={10} /></div>
        </div>
      </div>
    </SkeletonRegion>
  );
}

export function MyPageMobileSkeleton() {
  const s = useMyPageStrings();
  return (
    <SkeletonRegion label={s('myPage.loading')} data-testid="my-page-mobile-loading">
      <div aria-hidden style={{ display: 'grid', gap: 12, padding: '0 0.875rem' }}>
        <div style={{ ...card, padding: '12px 14px' }}>
          <Skeleton width="45%" height={14} />
          <Skeleton width="85%" height={12} />
          <Skeleton height={44} radius={10} />
          <Skeleton height={44} radius={10} />
        </div>
        <div style={{ ...card, padding: '12px 14px' }}>
          <Rows n={7} h={48} />
        </div>
      </div>
    </SkeletonRegion>
  );
}

export default MyPageSkeleton;
